// extracted by mini-css-extract-plugin
export default {"heading":"header_heading__xQT07","element":"header_element__NpNeO","floating":"header_floating__PyJar"};